import { useEffect } from "react";
import { useLocation } from "wouter";
import { useAuthUser } from "@/App";
import { useToast } from "@/hooks/use-toast";

export function useAdminGuard() {
  const user = useAuthUser();
  const [, setLocation] = useLocation();
  const { toast } = useToast();

  const isAdmin = !!(user?.isAdmin);

  useEffect(() => {
    if (user === null) {
      setLocation("/login");
      return;
    }
    if (user !== null && !user.isAdmin) {
      toast({
        title: "You don't have access to this page",
        variant: "destructive",
      });
      setLocation("/");
    }
  }, [user, setLocation, toast]);

  return { isAdmin, user };
}
